import { ArrowUpRight, BookOpen, Rocket, FileText, Compass } from "lucide-react";
import { LINKS } from "../../lib/links";

const RESOURCES = [
  {
    icon: BookOpen,
    title: "Free Idea To Income Guide",
    desc: "The exact playbook for taking an idea and turning it into your first income — completely free.",
    tag: "Free",
    href: LINKS.ideaToIncome,
    cta: "Get The Guide",
    featured: true,
  },
  {
    icon: Rocket,
    title: "How To Start A Business In 30 Days",
    desc: "A direct execution roadmap built from real launches.",
    tag: "Playbook",
    href: LINKS.stanStore,
    cta: "View on Stan Store",
  },
  {
    icon: FileText,
    title: "Templates & Worksheets",
    desc: "Operating templates used inside The Builder Programme.",
    tag: "Tools",
    href: LINKS.stanStore,
    cta: "View on Stan Store",
  },
  {
    icon: Compass,
    title: "1:1 Business Audit With Jordan",
    desc: "Book a private audit where Jordan reviews your business and gives you a clear path forward.",
    tag: "1:1",
    href: LINKS.businessAudit,
    cta: "Book Your Audit",
  },
];

export const Resources = () => {
  return (
    <section
      id="resources"
      data-testid="resources-section"
      className="relative bg-[#080808] py-24 md:py-40 border-t border-zinc-900"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16 md:mb-20">
          <div className="md:col-span-7">
            <div className="reveal flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-zinc-600" />
              <span className="text-xs tracking-[0.3em] uppercase text-zinc-400 font-bold">
                Resources
              </span>
            </div>
            <h2
              data-testid="resources-headline"
              className="reveal text-4xl sm:text-5xl lg:text-6xl tracking-tighter font-extrabold text-white leading-[1.02]"
            >
              Tools for{" "}
              <span className="italic font-light text-white">
                builders.
              </span>
            </h2>
          </div>
          <div className="md:col-span-5 flex md:items-end justify-start md:justify-end">
            <a
              href={LINKS.stanStore}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="resources-view-btn"
              className="reveal group inline-flex items-center gap-3 bg-white text-black font-bold text-sm tracking-[0.15em] uppercase px-7 py-4 hover:bg-zinc-200 transition-colors duration-300"
            >
              View All On Stan Store
              <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
            </a>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-zinc-900 border border-zinc-900">
          {RESOURCES.map((r, i) => {
            const Icon = r.icon;
            return (
              <a
                key={i}
                href={r.href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`resource-card-${i + 1}`}
                className={`reveal group relative transition-colors duration-500 p-8 md:p-12 flex flex-col ${
                  r.featured
                    ? "bg-[#0F0E0B] hover:bg-[#13110D]"
                    : "bg-[#0A0A0A] hover:bg-[#0F0F0F]"
                }`}
              >
                <div className="flex items-start justify-between mb-12">
                  <Icon
                    className={`w-7 h-7 transition-colors duration-300 ${
                      r.featured
                        ? "text-[#EDE6D5] group-hover:text-white"
                        : "text-zinc-400 group-hover:text-white"
                    }`}
                    strokeWidth={1.3}
                  />
                  <span
                    className={`text-[10px] tracking-[0.3em] uppercase font-bold px-2 py-1 ${
                      r.featured
                        ? "text-black bg-[#EDE6D5]"
                        : "text-zinc-600"
                    }`}
                  >
                    {r.tag}
                  </span>
                </div>
                <h3 className="text-2xl md:text-3xl tracking-tight font-bold text-white mb-3 leading-tight">
                  {r.title}
                </h3>
                <p className="text-sm md:text-base text-zinc-400 leading-relaxed mb-8 max-w-md">
                  {r.desc}
                </p>
                <div className="mt-auto flex items-center justify-between border-t border-zinc-900 pt-5">
                  <span className="text-xs tracking-[0.25em] uppercase text-zinc-500 group-hover:text-white transition-colors font-bold">
                    {r.cta}
                  </span>
                  <ArrowUpRight className="w-5 h-5 text-zinc-500 group-hover:text-white transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
};
